import React from "react";

import CorneredCard from "components/CorneredCard";
import "./AuthErrorPage.scss";

const UNAVAILABLE_MESSAGE =
  "The portal is temporarily unavailable, please contact administratie@cnb.nl";

const AuthErrorPage = ({ message = UNAVAILABLE_MESSAGE }) => (
  <div id="auth-error-container">
    <div className="auth-error-logo">
      <img src="/assets/images/logo.png" />
    </div>
    <CorneredCard className="auth-error-message" size="big">
      <h3>Error</h3>
      <p>{message}</p>
    </CorneredCard>
  </div>
);

export default AuthErrorPage;
